import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 0 24px;
    padding: 0px 0px 24px 0;
    font-family: ${theme.v3.font.family.brand};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin-top: 24px;
    }
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  ${({ theme }) => css`
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 2px 4px 0 ${theme.v3.colors.neutral[90]}24, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}33;
  `}
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;
